<div class="price-filter">
  <div class="ng-flex">
    <div class="price-filter__heading">
      <div class="price-filter__title">Ваш бюджет</div>
      <button *ngIf="hasSelectedFilter()"
              type="button"
              class="price-filter__reset"
              (click)="resetFilter()">
        Сбросить
      </button>
    </div>
    <div class="price-filter__inputs">
      <div class="price-filter__input-field price-filter__input-min">
        <span class="price-filter__input-label">От</span>
        <input #minInput type="text" class="price-filter__input"
               id="min-input"
               (blur)="commitMinInputValue()"
               (keydown.enter)="commitMinInputValue()">
      </div>
      <div class="price-filter__input-field price-filter__input-max">
        <span class="price-filter__input-label">До</span>
        <input #maxInput type="text" class="price-filter__input"
               id="max-input"
               (blur)="commitMaxInputValue()"
               (keydown.enter)="commitMaxInputValue()">
      </div>
    </div>
  </div>

  <div class="price-filter__slider">
    <div class="custom-slider">
      <ngx-slider
        [(value)]="minSliderValue"
        [(highValue)]="maxSliderValue"
        [options]="options"
        (userChange)="changeSlider($event)">
      </ngx-slider>
    </div>

    <div class="ng-flex">
      <div class="price-filter__slider-value price-filter__slider-min-value">
        {{ filterPrices.min.value | priceFormat:filterPrices.min.currency }}
      </div>
      <div class="price-filter__slider-value price-filter__slider-max-value">
        {{ filterPrices.max.value | priceFormat:filterPrices.max.currency }}
      </div>
    </div>
  </div>
</div>
